export async function loadRoasts(fetchImpl = fetch) {
  const response = await fetchImpl('/data/roasts.json');
  if (!response.ok) {
    throw new Error('Failed to load roasts.json');
  }
  return response.json();
}

export function managerRoasts(roasts, manager, limit = 4) {
  return (roasts?.per_manager?.[manager] || [])
    .filter((item) => item?.text)
    .slice(0, limit);
}

export function categoryRoasts(roasts, category, limit = 4) {
  return (roasts?.[category] || [])
    .filter((item) => item?.text)
    .slice(0, limit);
}

export function roastsByCategories(roasts, specs) {
  return specs.flatMap(({ category, label, limit = 1 }) => (
    categoryRoasts(roasts, category, limit).map((item) => ({
      ...item,
      category,
      label,
    }))
  ));
}
